export default "__VITE_ASSET__4DWAUEpM__"